import { stringify } from 'querystring';
import type SearchOrigin from '@alltrails/amplitude/enums/SearchOrigin';
import type SearchResultSelectionMethod from '@alltrails/amplitude/enums/SearchResultSelectionMethod';
import type SearchSuggestionSelectionType from '@alltrails/amplitude/enums/SearchSuggestionSelectionType';
import { wrapUrlSafe } from '@alltrails/core/utils/wrapUrlSafe';
import type { LanguageRegionCode } from '@alltrails/types/LanguageRegionCode';

// Matches to keys in @alltrails/filters/utils/exploreSearchParams.ts
const naturalLanguageQueryParamKey = 'nlq';
const naturalLanguageClickPositionParamKey = 'nlcp';
const naturalLanguageSelectionMethodParamKey = 'nlsm';
const naturalLanguageSelectionTypeParamKey = 'nlst';
const naturalLanguageSearchOriginParamKey = 'nlso';

type GetNaturalLanguageSearchUrlArgs = {
  query: string;
  clickPosition: number;
  languageRegionCode: LanguageRegionCode;
  selectionMethod?: SearchResultSelectionMethod;
  selectionType?: SearchSuggestionSelectionType;
  searchOrigin?: SearchOrigin;
};
const getNaturalLanguageSearchUrl = ({
  query,
  clickPosition,
  languageRegionCode,
  selectionMethod,
  selectionType,
  searchOrigin
}: GetNaturalLanguageSearchUrlArgs) => {
  const searchParams = new URLSearchParams(
    stringify({
      [naturalLanguageQueryParamKey]: query,
      [naturalLanguageClickPositionParamKey]: clickPosition,
      [naturalLanguageSelectionTypeParamKey]: selectionType,
      ...(selectionMethod ? { [naturalLanguageSelectionMethodParamKey]: selectionMethod } : {}),
      ...(searchOrigin ? { [naturalLanguageSearchOriginParamKey]: searchOrigin } : {})
    })
  );
  return wrapUrlSafe(`/explore?${decodeURIComponent(searchParams.toString())}`, languageRegionCode);
};

export default getNaturalLanguageSearchUrl;
